/**
 * Constructs a formatted document title string by joining the provided components with ' - '.
 *
 * This is the same logic used by MainLayout to construct document.title.
 * It is extracted here so that it can be reused by the useDocumentTitle hook
 * for pages that don't use MainLayout (e.g. FocusedTask pages, error pages).
 *
 * @param title - The page-specific title (e.g. "Create migration plan")
 * @param pageParentTitle - The parent page title (e.g. "Cloud migrations")
 * @param siteName - The site name from RouteIdContext (may be undefined)
 * @param orgName - The org name from RouteIdContext (may be undefined)
 * @param admin - The admin suffix (typically "Atlassian Administration")
 * @returns The formatted document title string
 */
export const formatDocumentTitle = (
	title: string,
	pageParentTitle: string,
	siteName: string | undefined | null,
	orgName: string | undefined,
	admin: string,
): string => {
	// Initializing doc title to construct
	const toReturnDocTitle: string[] = [];

	// Adding provided components to doc title
	if (title) toReturnDocTitle.push(title);
	if (pageParentTitle) toReturnDocTitle.push(pageParentTitle);
	if (siteName) toReturnDocTitle.push(siteName);
	if (orgName && orgName !== title) toReturnDocTitle.push(orgName);
	toReturnDocTitle.push(admin);

	// Join all components together with a hyphen
	return toReturnDocTitle.join(' - ');
};
